var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 499.687 499.687",
    height: 512,
    viewBox: "0 0 499.687 499.687",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m483.686 467.687h-451.686v-451.687c0-8.836-7.163-16-16-16s-16 7.164-16 16v467.687c0 8.836 7.163 16 16 16h467.686c8.837 0 16-7.164 16-16s-7.163-16-16-16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m73.282 448.601h93.099c8.837 0 16-7.164 16-16v-295.089c0-8.836-7.163-16-16-16h-93.099c-8.837 0-16 7.164-16 16v295.088c0 8.837 7.163 16.001 16 16.001zm16-295.089h61.099v263.088h-61.099z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m226.294 448.601h93.099c8.837 0 16-7.164 16-16v-404.23c0-8.836-7.163-16-16-16h-93.099c-8.837 0-16 7.164-16 16v404.23c0 8.836 7.164 16 16 16zm16-404.23h61.099v372.23h-61.099z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m379.308 448.601h93.099c8.837 0 16-7.164 16-16v-224.229c0-8.836-7.163-16-16-16h-93.099c-8.837 0-16 7.164-16 16v224.229c0 8.836 7.163 16 16 16zm16-224.229h61.099v192.229h-61.099z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.e4e81720e5e0e6d4e1a1ff0f00f57f82.svg";
export { ForwardRef as ReactComponent };